export const uniqueDigits = { uniqueDigits: "" };

export const USER_DETAILS = "userDetails";
export const COMMON_SSO_MOBILE = "mobileNumber";
export const CHECK_COOKIE = "checkCookie";
export const AUTH_TYPE = "authType";
export const PERPETUAL_TOKEN = "p_token";
export const MOBILE = "mobile";
export const CUST_ID = "custId";
export const USER_IDENTIFIER = "_si";
export const EXPIRED_TIME = "_expiredTime";
export const TOKEN_EXPIRY = "tokenExpiry";
export const REFRESH_KEY = "refresh";
export const TOKEN_SRC = "tokenSrc";
export const KEY = "key";
export const TOKEN = "token";
export const AIRTEL = "Airtel";
export const REQ_DATA = "reqData";
// this can be removed in the future, when react project is removed
export const LSFLAG = "_lsFlag";
export const M1_PARTNER_BUSINESS = "partnerBusiness";
export const M1_OFFER = "M1_OFFER";
export const M1_NO_OFFER = "M1_NO_OFFER";
export const NOTIFICATION_ENABLED = "notificationEnabled";

export const PARTNER_DATA = "partner_data";
